import { BaseDto } from '@/shared/dtos/base-dto';
import { dispositivo } from './dispositivo';

export class dispositivo_dashboard extends dispositivo {
    public id_dashboard !: number;
    public id_dispositivo !: number;
 } 
